// WHAT: Module for managing buzzer interception state
// WHY:  Provides global flag for enabling/disabling buzzer interception
// DOMAIN: Productivity → TimeTracQ
// DEPENDENCIES: None
// RISKS:
//   - NOTE: State is module-level - not reactive, may cause sync issues
//   - NOTE: No persistence - state is lost on page refresh

/**
 * WHAT:
 *   Module that provides functions for managing buzzer interception state.
 *   Buzzer interception allows the app to intercept buzzer events for
 *   automatic tracking.
 *
 * WHY:
 *   Enables/disables buzzer interception feature globally.
 *
 * BEHAVIOR:
 *   - Provides enableBuzzerInterception function
 *   - Provides disableBuzzerInterception function
 *   - Provides isBuzzerInterceptionEnabled function
 *   - Uses module-level state
 *
 * RISKS:
 *   - NOTE: State is module-level - not reactive, may cause sync issues
 *   - NOTE: No persistence - state is lost on page refresh
 */

let interceptorEnabled = false;

/**
 * WHAT:
 *   Enables buzzer interception.
 *
 * WHY:
 *   Allows app to intercept buzzer events for automatic tracking.
 */
export const enableBuzzerInterception = () => {
  interceptorEnabled = true;
};

/**
 * WHAT:
 *   Disables buzzer interception.
 *
 * WHY:
 *   Prevents app from intercepting buzzer events.
 */
export const disableBuzzerInterception = () => {
  interceptorEnabled = false;
};

/**
 * WHAT:
 *   Returns current buzzer interception state.
 *
 * WHY:
 *   Allows components to check if interception is enabled.
 *
 * @returns {boolean} True if buzzer interception is enabled, false otherwise
 *
 */
export const isBuzzerInterceptionEnabled = (): boolean => interceptorEnabled;
